import React from "react";
import {connect} from 'react-redux'

import Module from "./Module";
import {useParams} from "react-router-dom";

const Modulview = ({items}) => {
    const params = useParams();

    const modul = items.find(
        it => it.id === params.modulid || it.prettyname && it.prettyname.toLowerCase() === params.modulid.toLowerCase()
    )

    if( !modul) { return (<div/>) }

    return (
        modul?<>
            <div style={{
                userSelect: 'none',
            }}
            >
                <Module key={modul.id} modulid={modul.id} singleview={true}/>
            </div>
        </>:null
    )
}

function mapStateToProps(state, other) {

    return {items: state.plan.items};
}

export default connect(mapStateToProps)(Modulview)